export const colors = {
  primary: "#F2295B",
  white: "#FFFFFF",
  black: "#000000",
  primaryDark: "#2a002D",
  blueGray: "#2F4251",
  blueGray2: "#96A4B0",
  darkGray: "#595858",
  grayText: "#929292",
  gray3: "#486270",
  gray4: "#DDDDDD",
  gray5: "#666666",
  gray6: "#F5F5F5",
  gray7: "#707070",
  gray8: "#EEEEEE",
  gray9: "#FAFAFA",
  gray10: "#87868D",
  gray11: "#00000073",
  gray12: '#F4F4F4',
  gray13: '#EAEAEA',
  gray14: '#979797',
  gray15: '#D9D9D9',
  gray16: '#707070',
  gray17: '#455A64',
  border: "#E4E4E4",
  lightTeal: "#F5F8FA",
  green: "#016E00",
  darkGreen: "#015D00",
  pink: "#FD5277",
  separator: "#8080809B",
  red: "#E2665F",
  catskillWhite: "#f5f8fa",
  quote: "#286270",
  whiteBorder: "#D9D9D9",
}

export const gradient = {
  primary: `linear-gradient(30deg, ${colors.primaryDark} 9%, ${colors.primary} 76%)`,
}
